import { AddStaticText } from "../utils/AddStaticText";
import { AddStdTextEdit } from "../utils/AddStdTextEdit";
import { appstr } from "../utils/appstr";
import {
  enumKeyboardTargetEnterAction,
  enumPanelBorderStyle,
  enumShortCutModKeys,
  kCCPHeight,
  kEnterOKShortCut,
  kRed,
  kStdTEHeight
} from "../constants";
import { QPanel } from "./QPanel";
import { AddStdButtonAutoPos } from "../utils/AddStdButtonAutoPos";

export class QCustomColorPicker extends QPanel {
  constructor() {
    super();
    this.fRGBValue = null;
    this.fMessage = null;
    this.fWSMgr = null;

    this.fColorIndex = null;
    this.fColorList = null;
    this.fSrcElement = null;
  }

  InitCustomColorPicker(wsMgr, theWidth, colorList, colorIndex, srcElement) {
    this.fColorIndex = colorIndex;
    this.fColorList = colorList;

    if (srcElement) srcElement = srcElement["parent"];
    this.fSrcElement = srcElement;

    this.fWSMgr = wsMgr;
    this.fUIColors = wsMgr.GetUIColors();

    this.SizePanel(theWidth, kCCPHeight);
    this.SetModalOn(true);
    this.SetFillColor(this.fUIColors.GetSecondaryPanelFillColor());
    this.SetShadowOn(true);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);
    this.SetNeedsCustomResize(true);

    this.fTextColor = this.fUIColors.GetHeaderTextColor();
    var indent = 10;
    var teWidth = theWidth - 2 * indent;
    var yPos = 6;

    var initialVal = colorList[colorIndex];
    initialVal = initialVal.substring(1);

    var s = appstr("hexcolor") + ":";
    AddStaticText(this, indent, yPos, s, false, this.fTextColor);
    yPos += 20;

    this.fRGBValue = AddStdTextEdit(
      this,
      indent,
      yPos,
      teWidth,
      kStdTEHeight,
      appstr("enterrgb"),
      44,
      0,
      true
    );
    this.fRGBValue.SetEditContent(initialVal);

    yPos += 20;
    this.fMessage = AddStaticText(this, indent, yPos, "", false, kRed);

    yPos = kCCPHeight - 30;
    var buttonHeight = 20;
    var buttonMargin = indent;
    var butWidth = 50;

    var xRight = theWidth - buttonMargin;
    var okBut = AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("OK"),
      null,
      null,
      false,
      "OKCCP"
    );
    okBut.SetCmdShortCut(kEnterOKShortCut, enumShortCutModKeys.none, "");

    xRight = okBut.GetPositionX() - buttonMargin;
    AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("Cancel"),
      null,
      null,
      false,
      "CancelCCP"
    );
  }

  BecomeKeyboardTarget() {
    var wsMgr = this.fWSMgr;
    wsMgr.SetKeyboardTarget(this.fRGBValue, this, enumKeyboardTargetEnterAction.selectAll);
  }

  DoCustomResize() {
    this.fWSMgr.RemovePanel(this);
  }

  SetMsg(theMessage) {
    this.fMessage.SetLabel(theMessage);
    this.fMessage.AutoSize();
  }

  Validate() {
    this.SetMsg("");
    var o = this.fRGBValue.GetRealContent();
    // var okLen =  (o.length == 6);
    var isOk = /^[0-9A-F]{6}$/i.test(o);

    if (!isOk) this.SetMsg(appstr("colorvalmin"));

    return isOk;
  }

  ChangeOrgInfoResult(success) {
    var wsMgr = this.fWSMgr;
    if (success) wsMgr.RemovePanel(this);
    else {
      this.SetMsg(appstr("orginfochgfail"));
      wsMgr.SetKeyboardTarget(this.fRGBValue, this, enumKeyboardTargetEnterAction.selectAll);
    }
    wsMgr.RenderWS();
  }

  DoTransaction() {
    var wsMgr = this.fWSMgr;
    var oi = wsMgr.GetOrgInfo();
    var newColor = "#" + this.fRGBValue.GetRealContent();
    this.fColorList[this.fColorIndex] = newColor;
    oi.SetCustomColors(this.fColorList);

    if (this.fSrcElement) this.fSrcElement.SetInteriorColor(newColor);

    //UpdateTheme(this, [{ customcolors: this.fColorList }]);
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var panelHandled = false;

    switch (cmdCode) {
      case "OKCCP":
        var pass = this.Validate();
        if (pass) this.DoTransaction();
        panelHandled = true;
        break;
      case "CancelCCP":
      case "CNCL":
        panelHandled = true;
        wsMgr.RemovePanel(this);
        break;
    }

    return panelHandled;
  }
}
